var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<section ng-if=\"!options.data.readOnly\">\n<formly-transclude></formly-transclude>\n</section>\n<section ng-if=\"options.data.readOnly\">\n<input disabled=\"disabled\" ng-value=\"model[options.key]\" class=\"form-control\"/>\n</section>\n";
var id1="bssreadonly.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;